<app-pop-up class="background">
  <app-pop-up-header
    [headerName]="'Excel import'"
    (close)="close()"
  ></app-pop-up-header>
  <div class="spacer"></div>

  <app-pop-up-body>
    <div class="main-wrapper">
      <span class="div-style">Import File</span>
      <div
        appDragDrop
        (onFileDropped)="onUploadFile($event)"
        style="display: flex"
        class="upload-file-outer-container"
        [hidden]="fileuploaddone"
      >
        <div class="uploadfilecontainer align-center">
          <input
            hidden
            type="file"
            #fileInput
            (change)="onUploadFile($event.target.files)"
          />
          <i class="fa fa-upload fa-lg"></i>
          <div>
            <span class="box__dragndrop" *ngIf="!workflowID"
              >Drag your excel file to add new users
            </span>
            <span class="box__dragndrop" *ngIf="workflowID"
              >Drag your excel file
            </span>
            <div>or</div>
          </div>
          <span class="align-center-btns">
            <div class="spacer"></div>
            <app-button
              [type]="'primary'"
              [name]="'upload file'"
              (btnClick)="fileInput.value = null; fileInput.click()"
            ></app-button>
            <div class="spacer"></div>
          </span>

          <div class="align-center" *ngIf="!workflowID" for="file">
            <div class="template">
              <button class="button-link" (click)="downloadTemplate()">
                <a download class="template"> Download sample template </a>
              </button>
            </div>
          </div>
        </div>
      </div>

      <app-loader [isPage]="true" *ngIf="formSubmitted"></app-loader>

      <app-alert *ngIf="successfulImport" [alert]="warningalert"></app-alert>
      <div *ngIf="successfulImport">
        <div
          *ngFor="let file of files; let i = index"
          class="file-name-container"
          [hidden]="!fileuploaddone"
        >
          <div class="filename">{{ file.name }}</div>
          <div class="date-time">
            {{ file.lastModifiedDate | date : "dd MMM, yyyy" }} at
            {{ file.lastModifiedDate | date : "HH:mm" }} &bull;
            {{ uploadedFileSize }}
          </div>
        </div>
      </div>

      <app-alert [alert]="alert"></app-alert>

      <div *ngIf="alertMessages && alertMessages.length">
        <div *ngFor="let message of alertMessages; let i = index">
          <app-alert [alert]="message"></app-alert>
          <div class="addspace"></div>
        </div>
      </div>
    </div>
  </app-pop-up-body>

  <app-pop-up-footer>
    <!-- <div class="spacer"></div> -->
    <app-button
      [type]="'outlined'"
      [name]="'Cancel'"
      (btnClick)="close()"
    ></app-button>
    <app-button
      [type]="'primary'"
      [name]="'Done'"
      (btnClick)="done()"
    ></app-button>
  </app-pop-up-footer>
</app-pop-up>
